import { render, staticRenderFns } from "./LandingPageBuiltInSection.vue?vue&type=template&id=083c156c&scoped=true"
import script from "./LandingPageBuiltInSection.vue?vue&type=script&lang=js"
export * from "./LandingPageBuiltInSection.vue?vue&type=script&lang=js"
import style0 from "./LandingPageBuiltInSection.vue?vue&type=style&index=0&id=083c156c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c156c",
  null
  
)

export default component.exports